import { render, staticRenderFns } from "./ExaminationDetailPage.vue?vue&type=template&id=65e5af4a&scoped=true&"
import script from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
export * from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationDetailPage.vue?vue&type=style&index=0&id=65e5af4a&prod&lang=scss&"
import style1 from "./ExaminationDetailPage.vue?vue&type=style&index=1&id=65e5af4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5af4a",
  null
  
)

export default component.exports